<template>
  <client-only>
    <div class="layout">

      <logged-in-header prefix="viewer"></logged-in-header>
      <main class="content">
        <slot />
      </main>
      <footer>
        <!-- Viewer Footer content -->
      </footer>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import LoggedInHeader from "~/components/core/header/LoggedInHeader.vue";

definePageMeta({
  middleware: 'auth',
  name: 'viewer-layout',
  viewer: true
});

onMounted(() => {
  console.log('viewer layout');
});
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  flex: 1;
  /* This makes the content area grow to fill the available space */
  display: flex;
  flex-direction: column;
}
</style>
